(() => {
  if (window.StlModalSwatches) return;

  const productHandleFromUrl = raw => {
    if (!raw) return '';
    try {
      const path = new URL(raw, window.location.origin).pathname;
      const m = path.match(/\/products\/([^/]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch {
      return '';
    }
  };

  /** Deep clones of `shop-look-swatches` from first open — reused on color switch so markup stays unchanged. */
  let stlSwatchesMasterClones = null;

  const snapshotStlSwatchesFromModal = modal => {
    if (!modal) return;
    const list = modal.querySelectorAll('shop-look-swatches');
    if (!list.length) {
      stlSwatchesMasterClones = null;
      return;
    }
    stlSwatchesMasterClones = [...list].map(el => el.cloneNode(true));
  };

  /** Apply snapshot while `hostEl` is off-document to avoid a paint with server swatches. */
  const restoreStlSwatchesFromSnapshotInto = hostEl => {
    if (!hostEl || !stlSwatchesMasterClones?.length) return;
    const current = [...hostEl.querySelectorAll('shop-look-swatches')];
    current.forEach((el, i) => {
      const master = stlSwatchesMasterClones[i];
      if (master) el.replaceWith(master.cloneNode(true));
    });
  };

  const syncStlSwatchActiveForHandle = (modal, handle) => {
    if (!modal || !handle) return;
    modal
      .querySelectorAll('.product-color_swatch__wrap[data-product-url]')
      .forEach(el => {
        const h = productHandleFromUrl(el.dataset.productUrl);
        el.classList.toggle('swatch-active', h === handle);
      });
  };

  const captureSwatchHashValues = hostEl => {
    if (!hostEl) return {};
    const result = {};
    const core = hostEl.querySelector('.shop-the-look_swatch-title-hash.core');
    const limited = hostEl.querySelector(
      '.shop-the-look_swatch-title-hash.limited'
    );
    const defaultHash = hostEl.querySelector(
      '.shop-the-look_swatch-container-default .shop-the-look_swatch-title-hash'
    );
    if (core) result.core = core.textContent.trim();
    if (limited) result.limited = limited.textContent.trim();
    if (defaultHash) result.default = defaultHash.textContent.trim();
    return result;
  };

  const applySwatchHashValues = (hostEl, values) => {
    if (!hostEl || !values) return;
    const core = hostEl.querySelector('.shop-the-look_swatch-title-hash.core');
    const limited = hostEl.querySelector(
      '.shop-the-look_swatch-title-hash.limited'
    );
    const defaultHash = hostEl.querySelector(
      '.shop-the-look_swatch-container-default .shop-the-look_swatch-title-hash'
    );
    if (core && values.core != null) core.textContent = values.core;
    if (limited && values.limited != null) limited.textContent = values.limited;
    if (defaultHash && values.default != null) {
      defaultHash.textContent = values.default;
    }
  };

  const updateHashForClickedSwatch = swatch => {
    if (!swatch) return;
    const value = swatch.dataset.colorName || '';
    const coreContainer = swatch.closest(
      '.shop-the-look_swatch-container-core'
    );
    const limitedContainer = swatch.closest(
      '.shop-the-look_swatch-container-limited'
    );
    const defaultContainer = swatch.closest(
      '.shop-the-look_swatch-container-default'
    );

    if (coreContainer) {
      const hash = coreContainer.querySelector(
        '.shop-the-look_swatch-title-hash.core'
      );
      if (hash) hash.textContent = value;
      return;
    }
    if (limitedContainer) {
      const hash = limitedContainer.querySelector(
        '.shop-the-look_swatch-title-hash.limited'
      );
      if (hash) hash.textContent = value;
      return;
    }
    if (defaultContainer) {
      const hash = defaultContainer.querySelector(
        '.shop-the-look_swatch-title-hash'
      );
      if (hash) hash.textContent = value;
    }
  };

  const syncHashesFromActiveSwatches = modal => {
    if (!modal) return;

    const coreActive = modal.querySelector(
      '.shop-the-look_swatch-items.core .product-color_swatch__wrap.swatch-active'
    );
    const limitedActive = modal.querySelector(
      '.shop-the-look_swatch-items.limited .product-color_swatch__wrap.swatch-active'
    );

    const coreHash = modal.querySelector(
      '.shop-the-look_swatch-title-hash.core'
    );
    const limitedHash = modal.querySelector(
      '.shop-the-look_swatch-title-hash.limited'
    );

    if (coreHash) {
      coreHash.textContent = coreActive?.dataset.colorName || '';
    }
    if (limitedHash) {
      limitedHash.textContent = limitedActive?.dataset.colorName || '';
    }

    const defaultActive = modal.querySelector(
      '.shop-the-look_swatch-container-default .product-color_swatch__wrap.swatch-active'
    );
    if (defaultActive) updateHashForClickedSwatch(defaultActive);
  };

  const STL_VARIANT_PICK_SELECTOR =
    '.stl-bundle-variant-pick[data-stl-product-url], .stl-supplement-flavor-pick[data-stl-product-url]';

  const activateBundlePickLocally = (bundlePick, paletteRoot) => {
    paletteRoot
      ?.querySelectorAll(
        '.stl-bundle-variant-pick, .stl-supplement-flavor-pick'
      )
      .forEach(el => {
        el.classList.remove('active');
        el.removeAttribute('aria-current');
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'button');
      });
    bundlePick.classList.add('active');
    bundlePick.setAttribute('aria-current', 'true');
    bundlePick.setAttribute('tabindex', '-1');
    bundlePick.removeAttribute('role');
  };

  const handleBundleVariantPick = (e, modal) => {
    const bundlePick = e.target.closest(STL_VARIANT_PICK_SELECTOR);
    if (!bundlePick) return false;

    const isB2b = window.__stlModalSectionDeps?.isB2bBody?.();
    if (isB2b) return true;

    if (!modal?.classList.contains('active')) return true;

    const productUrl = bundlePick.dataset.stlProductUrl;
    if (!productUrl) return true;

    const currentHandle = modal.dataset.productHandle ?? '';
    const nextHandle = productHandleFromUrl(productUrl);

    if (nextHandle && currentHandle && nextHandle === currentHandle) {
      const paletteRoot = bundlePick.closest(
        '.stl-bundle-palette-root, .stl-supplement-flavor-palette'
      );
      activateBundlePickLocally(bundlePick, paletteRoot);
      return true;
    }

    const prevActive = bundlePick
      .closest('.stl-bundle-palette-root, .stl-supplement-flavor-palette')
      ?.querySelector(
        '.stl-bundle-variant-pick.active, .stl-supplement-flavor-pick.active'
      );
    const prevLabel =
      prevActive?.dataset?.flavorName || prevActive?.dataset?.colorName || '';
    const newLabel =
      bundlePick.dataset?.flavorName || bundlePick.dataset?.colorName || '';

    e.preventDefault();

    const fetchFn = window.__stlModalSectionDeps?.fetchAndApplyStlModal;
    if (typeof fetchFn !== 'function') return true;

    void (async () => {
      const updated = await fetchFn(productUrl, {
        replaceWhileOpen: true
      });
      if (!updated) return;
      const a = window.StlModalAnalytics;
      if (a && typeof a.fireProductColorChangeAnalytics === 'function') {
        a.fireProductColorChangeAnalytics(updated, prevLabel, newLabel);
      }
    })();

    return true;
  };

  /** During open swap: re-apply master swatch clones + active handle when snapshot exists. */
  const restoreSnapshotForSwapImport = imported => {
    if (!stlSwatchesMasterClones?.length || !imported) return;
    restoreStlSwatchesFromSnapshotInto(imported);
    syncStlSwatchActiveForHandle(
      imported,
      imported.dataset.productHandle ?? ''
    );
  };

  const handleColorSwatchPick = (e, root, modal) => {
    const swatch = e.target.closest(
      '.product-color_swatch__wrap[data-product-url]'
    );
    if (!swatch) return false;

    const isB2b = window.__stlModalSectionDeps?.isB2bBody?.();
    if (isB2b) return true;

    if (!modal?.classList.contains('active')) return true;

    const productUrl = swatch.dataset.productUrl;
    if (!productUrl) return true;

    const currentHandle = modal.dataset.productHandle ?? '';
    const nextHandle = productHandleFromUrl(productUrl);

    if (nextHandle && currentHandle && nextHandle === currentHandle) {
      root
        .querySelectorAll('.product-color_swatch__wrap.swatch-active')
        .forEach(el => {
          el.classList.remove('swatch-active');
        });
      swatch.classList.add('swatch-active');
      updateHashForClickedSwatch(swatch);
      syncHashesFromActiveSwatches(modal);
      return true;
    }

    const prevSwatch = root.querySelector(
      '.product-color_swatch__wrap.swatch-active'
    );
    const prevColor = prevSwatch?.dataset.colorName ?? '';
    const newColor = swatch.dataset.colorName ?? '';

    e.preventDefault();

    const fetchFn = window.__stlModalSectionDeps?.fetchAndApplyStlModal;
    if (typeof fetchFn !== 'function') return true;

    void (async () => {
      const updated = await fetchFn(productUrl, {
        replaceWhileOpen: true
      });
      if (!updated) return;
      const a = window.StlModalAnalytics;
      if (a && typeof a.fireProductColorChangeAnalytics === 'function') {
        a.fireProductColorChangeAnalytics(updated, prevColor, newColor);
      }
    })();

    return true;
  };

  window.StlModalSwatches = {
    clones: {
      snapshotFromModal: snapshotStlSwatchesFromModal,
      restoreForSwap: restoreSnapshotForSwapImport
    },
    hashes: {
      capture: captureSwatchHashValues,
      apply: applySwatchHashValues,
      syncActive: syncHashesFromActiveSwatches
    },
    picks: {
      bundleVariant: handleBundleVariantPick,
      colorSwatch: handleColorSwatchPick
    }
  };
})();
